import { render, staticRenderFns } from "./Lobster.vue?vue&type=template&id=1d287b34&scoped=true&lang=pug"
import script from "./Lobster.vue?vue&type=script&lang=js"
export * from "./Lobster.vue?vue&type=script&lang=js"
import style0 from "./Lobster.vue?vue&type=style&index=0&id=1d287b34&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d287b34",
  null
  
)

export default component.exports